import React, { useEffect, useState, useRef } from "react";
import { Link } from 'react-router-dom';
import { Space, Button, Flex } from 'antd';
import '../styles/card.css';
import { useTranslation } from "react-i18next";

const Card = ({ title, info, onUpdateValue }) => {

	const { t, i18n: { changeLanguage, language } } = useTranslation();
	const [blobUrl, setBlobUrl] = useState('');

	const handleChange = () => {
		onUpdateValue(info);
	};

	useEffect(() => {
		// Step 1: Create the SVG string
		const svgString = info;
	 
		// Step 2: Convert the SVG string to a Blob
		const blob = new Blob([svgString], { type: 'image/svg+xml' });
	 
		// Step 3: Generate a URL for the Blob
		const url = URL.createObjectURL(blob);
		setBlobUrl(url);
	 
		// Step 4: Cleanup function to revoke the Blob URL
		return () => {
		  URL.revokeObjectURL(url);
		};
	   }, []);

	return (
		<div className="card" style={{ width: (290), padding: 5, backgroundColor: 'white' }}>
			<Flex justify="center" align="center" style={{ maxWidth: 280, maxHeight: 200, minHeight: 200 }}>
				{blobUrl && <img src={blobUrl} alt="Etiqueta" style={{maxWidth: '100%', maxHeight: '100%',objectFit: 'scale-down',}}/>}
			</Flex>
			<Flex justify="center" align="center">
				<Button onClick={handleChange}>Selecionar</Button>
			</Flex>
		</div>
	);

};

export default Card;